(function ($) {

    'use strict';

    const FlipCard = function () {

        let $flipCard = $('.flip-card');

				const CLASSES = {
					card: 'flip-card',
					front: 'flip-card__front',
					back: 'flip-card__back',
					description: 'flip-card__description',
					link: 'flip-card__link',
					close: 'flip-card__close',
					flipped: 'flip-card--flipped',
				}

				const init = function () {
					if ($flipCard) {
            _setupFlipCards();
            _addEvents();
					}
        };

        /**
         * Setup Flipcards
         */
        const _setupFlipCards = function () {
					$flipCard.each(
						function(i, el) {
							const $el = $(el)
							const $front = $el.find('.' + CLASSES.front);
							const $back = $el.find('.' + CLASSES.back);
							const minHeight = Math.max(
								$front.innerHeight(),
								$back.innerHeight()
							);

							$el.css('min-height', minHeight);
						}
					)
        };

        /**
         * Add Events
         */
        const _addEvents = function () {
					$flipCard.find('[data-js-flip-card-toggle]').on('click', handleClick);
					$(window).on('resize', _setupFlipCards);
        };


				const handleClick = function(event) {
					const $card = $(event.currentTarget).parents('.' + CLASSES.card);
					const $desc = $card.find('.' + CLASSES.description);
					const $link = $card.find('.' + CLASSES.link);
					const $front = $card.find('.' + CLASSES.front);
					const $close = $card.find('.' + CLASSES.close);

					_toggleCard($card);

					const isOpen = _getIsOpen($card);

					// Prevent focus on hidden elements
					if (isOpen) {
						_show($desc);
						_show($link);
						_show($close);
						$desc.focus();
						_hide($front);
					} else {
						_show($front);
						$front.focus();
						_hide($desc);
						_hide($link);
						_hide($close);
					}
				}

				const _toggleCard = function (card) {
					const $card = $(card);
					const isOpen = _getIsOpen($card);

					$card.toggleClass(CLASSES.flipped, !isOpen);
				}

				const _getIsOpen = function (card) {
					return $(card).hasClass(CLASSES.flipped)
				}

				const _show = function (el) {
					$(el).attr('tabindex', 0).attr('aria-hidden', false);
				}

				const _hide = function (el) {
					$(el).attr('tabindex', -1).attr('aria-hidden', true);
				}

        return {
            init: init
        };

    }();

    module.exports = FlipCard;

})(jQuery);
